import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		request_error: false,
		show_login: false,
		show_team_login: false,
		base_info: {},
		ticket_type: 'personal',//当前票务类型，默认个人票务
		team_login_info:{},
		personal_user_info:{}
	},
	mutations: mutations
});
export default store


// WEBPACK FOOTER //
// ./src/store/index.js